import axios from './../plugins/private-api-axios'

export const deviceService = {
    urlPrefix: '/vehicleDevices',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async createDevice (vehicleId, recorderId, deviceTypeId, isDisabled, usedIntegration, dataToCapture) {
        try {
            return await axios.post(this.urlPrefix, {
                vehicleId: vehicleId,
                recorderId: recorderId,
                deviceTypeId: deviceTypeId,
                isDisabled: isDisabled,
                usedIntegration: usedIntegration,
                dataToCapture: dataToCapture
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async createMultipleDevices (file) {
        try {
            return await axios.post(`${this.urlPrefix}/importDevices`, file, this.config)
        } catch (e) {
            throw e
        }
    },
    async getDevices (page, perPage, vehicleId, recorderId) {
        let urlBuilder = {}

        if (null != page && null != perPage) {
            urlBuilder.skip = (page - 1) * perPage
            urlBuilder.take = perPage
        }

        if (null != vehicleId) {
            urlBuilder.VehicleId = vehicleId
        }

        if (null != recorderId) {
            urlBuilder.RecorderId = recorderId
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getDevice (uuid) {
        try {
            return await axios.get(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async editDevice (uuid, vehicleId, recorderId, deviceTypeId, isDisabled, usedIntegration, dataToCapture) {
        try {
            return await axios.put(`${this.urlPrefix}/${uuid}`, {
                vehicleId: vehicleId,
                recorderId: recorderId,
                deviceTypeId: deviceTypeId,
                isDisabled: isDisabled,
                usedIntegration: usedIntegration,
                dataToCapture: dataToCapture
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async deleteDevice (uuid) {
        try {
            return await axios.delete(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateDeviceService = (accessToken) => {
    deviceService.config.headers.Authorization = accessToken
}

export default deviceService
